<template>
  <div>
    <template v-if="additionalFieldType === 'select'">
      <VSelect
        v-model="additionalInput"
        :items="addField.availableValues"
        outlined
        :menu-props="{ offsetY: true, nudgeBottom: 10, attach: true }"
        :error-messages="additionalFieldError"
        @change="changeInputValue"
      >
        <template v-slot:label>
          {{ additionalFieldLabel }} <span v-if="additionalFieldRequired" class="red--text">*</span>
        </template>
      </VSelect>
    </template>
    <template v-else>
      <VTextField
        v-model="additionalInput"
        outlined
        dense
        :error-messages="additionalFieldError"
        @input="changeInputValue"
      >
        <template v-slot:label>
          {{ additionalFieldLabel }} <span v-if="additionalFieldRequired" class="red--text">*</span>
        </template>
      </VTextField>
    </template>
  </div>
</template>

<script>
import {
  ref, toRefs, computed,
} from '@vue/composition-api';

export default {
  name: 'CandidateCreateFormAdditionalInput',
  props: {
    addField: {
      type: Object,
      required: true,
    },
    error: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { addField, error } = toRefs(props);

    const additionalFieldType = computed(() => addField.value.type);
    const additionalFieldLabel = computed(() => addField.value.label);
    const additionalFieldRequired = computed(() => addField.value.required);
    const additionalFieldValue = computed(() => addField.value.value);
    const additionalFieldError = computed(() => error.value[`additionalFields.${additionalFieldValue.value}`]);

    const additionalInput = ref(null);

    function changeInputValue() {
      emit('setAdditionalValue', additionalInput.value, additionalFieldValue.value);
      if (error.value.hasOwnProperty(`additionalFields.${additionalFieldValue.value}`)) {
        emit('clearError');
      }
    }

    return {
      additionalInput,
      changeInputValue,
      additionalFieldType,
      additionalFieldLabel,
      additionalFieldRequired,
      additionalFieldError,
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-select {
    .v-input__control {
      .v-input__slot {
        max-height: 40px !important;
        min-height: 40px !important;
        .v-select__slot {
          .v-input__append-inner {
            margin-top: 8px !important;
          }
          .v-label {
            top: auto !important;
          }
        }
      }
    }
  }
  .v-text-field--outlined .v-label--active {
    transform: translateY(-18px) scale(0.75) !important;
  }
  .v-list-item {
    min-height: 40px;
    .v-list-item__content {
      .v-list-item__title {
        font-size: 13px;
        color: #000;
      }
    }
  }
}
</style>
